import { TranslateService } from '@ngx-translate/core';

// Maps AiToolDefinition.ToolId (raw, kebab-case, see *AiToolHandler.cs) to a translation key
// under App.AIChat.Tools. Falls back to App.AIChat.ToolFallback for any unmapped/new tool id
// so the indicator degrades gracefully instead of showing a blank or raw id.
const TOOL_LABEL_KEYS: Record<string, string> = {
	'debtor-read': 'App.AIChat.Tools.debtor-read',
	'get-accounting-document-details': 'App.AIChat.Tools.get-accounting-document-details',
	'get-client-details': 'App.AIChat.Tools.get-client-details',
	'get-client-dunning-scenario-with-templates': 'App.AIChat.Tools.get-client-dunning-scenario-with-templates',
	'get-client-linked-documents': 'App.AIChat.Tools.get-client-linked-documents',
	'get-context': 'App.AIChat.Tools.get-context',
	'get-dunning-scenario-details': 'App.AIChat.Tools.get-dunning-scenario-details',
	'get-feature-flags': 'App.AIChat.Tools.get-feature-flags',
	'list-dunning-groups': 'App.AIChat.Tools.list-dunning-groups',
	'list-dunning-scenarios': 'App.AIChat.Tools.list-dunning-scenarios',
	'list-dunning-templates': 'App.AIChat.Tools.list-dunning-templates',
	'search-accounting-documents': 'App.AIChat.Tools.search-accounting-documents',
	'search-clients': 'App.AIChat.Tools.search-clients',
	'search-completed-dunning-actions': 'App.AIChat.Tools.search-completed-dunning-actions',
	'search-portfolios': 'App.AIChat.Tools.search-portfolios',
	'search-upcoming-dunning-actions': 'App.AIChat.Tools.search-upcoming-dunning-actions',
	'trigger-export': 'App.AIChat.Tools.trigger-export',
}

export function getToolLabel(toolName: string | null | undefined, i18n: TranslateService): string {
	const key = toolName ? TOOL_LABEL_KEYS[toolName] : undefined
	return i18n.instant(key ?? 'App.AIChat.ToolFallback')
}
